import { KenoDataServiceAPI } from '@API/gambyt-data-services/keno-api'
import { TicketResult } from '@API/game-results/types'
import { DataFetchingState } from '@AppState/types'
import { TicketInfo } from '@Config/ticket-form-types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { NAV_VALUES } from './types'

type TicketModeState = {
  fetchState: DataFetchingState
  activeTicket: TicketInfo | null
  activeTicketResults: TicketResult | null
  activeMenu: NAV_VALUES
}

const initialState: TicketModeState = {
  fetchState: DataFetchingState.IDLE,
  activeTicket: null,
  activeTicketResults: null,
  activeMenu: NAV_VALUES.EDIT,
}

export const fetchTicketResults = createAsyncThunk(
  'ticket-mode/fetchTicketResults',
  async (ticketInfo: TicketInfo) => {
    const result = await KenoDataServiceAPI.fetchTicketResult(ticketInfo)
    return {
      ticketInfo,
      result: result ?? null,
    }
  },
)

export const ticketModeSlice = createSlice({
  name: 'ticket-form',
  initialState,
  reducers: {
    updateActiveMenu(state, action) {
      state.activeMenu = action.payload
    },
    updateTicketForm(state, action) {
      state.activeTicket = action.payload
    },
    resetFetchState() {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTicketResults.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.activeTicket = action.payload.ticketInfo
      state.activeTicketResults = action.payload.result
    })
    builder.addCase(fetchTicketResults.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
    })
    builder.addCase(fetchTicketResults.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.activeTicket = null
      state.activeTicketResults = null
    })
  },
})

export const TicketModeActions = {
  ...ticketModeSlice.actions,
}

export const TicketModeReducer = ticketModeSlice.reducer
